module.exports = __webpack_public_path__ + "static/img/052.995ee9f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/lkpy/052.png
// module id = XPY2
// module chunks = 0